import core from './modules/core/router/routes';
import type { RouteRecordRaw } from 'vue-router';

import { authRoutes, authMainRoutes } from '@shared';

import customer from './modules/customer/router/routes';
import offer from './modules/offer/router/routes';
import offerCalculator from './modules/offer-calculator/router/routes';
import order from './modules/order/routes/routes';
import product from './modules/product/routes/routes';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    children: [
      {
        path: '',
        component: () => import('./components/layouts/MainLayout.vue'),
        children: [...core, ...offer, ...customer, ...offerCalculator, ...order, ...product, ...authMainRoutes]
      },
      {
        path: '',
        component: () => import('./components/layouts/LoginLayout.vue'),
        children: [...authRoutes]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: () => import('./modules/core/pages/ErrorPage.vue')
  }
];

export default routes;
